import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGasPump, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faServicestack } from "@fortawesome/free-brands-svg-icons";

const estacionesCol1 = [
  {
    nombre: "Estanción de Servicio GNC Oliva",
    link: "https://maps.app.goo.gl/k1dMtUPWPtBTyGGj6",
    direccion: "Leandro N. Alem 501.",
  },
  {
    nombre: "Shell",
    link: "https://maps.app.goo.gl/k2FxAusXL5K3jrj27",
    direccion: "Esquina Roque Sáenz Peña y Pueyrredón.",
  },
  {
    nombre: "YPF Santo Tomas Oliva",
    link: "https://maps.app.goo.gl/crDZ4LydSFYXH2uf7",
    direccion: "Leandro N. Alem 513.",
  },
];

const estacionesCol2 = [
  {
    nombre: "Estación de Servicio El Milagro",
    link: "https://maps.app.goo.gl/VDx5amJzsg9UVL8o8",
    direccion: "Roque Sáenz Peña.",
  },
  {
    nombre: "Estación de Servicio Don Ángel GNC",
    link: "https://maps.app.goo.gl/c55141Lxxi4kcdU5A",
    direccion: "Calle Italia – RUTA PROVINCIAL Nº10.",
  },
];

const EstacionesServicio = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon
            icon={faGasPump}
            style={{ color: "#c0392b", marginRight: 8 }}
          />
          Estaciones de Servicio
        </h5>
        <ul className="lista-referencias">
          {estacionesCol1.map((est, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={est.link} target="_blank" rel="noopener noreferrer">
                {est.nombre}
              </a>
              <div className="ms-2 me-auto">{est.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <ul className="lista-referencias">
          {estacionesCol2.map((est, i) => (
            <li key={i}>
              <FontAwesomeIcon
                icon={faMapLocationDot}
                style={{ marginRight: 8 }}
              />
              <a href={est.link} target="_blank" rel="noopener noreferrer">
                {est.nombre}
              </a>
              <div className="ms-2 me-auto">{est.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default EstacionesServicio;